import React from 'react';
import { If } from '../If/If';
import { FinancialStatus } from '../../enums/FinancialStatus';
import { Container } from './styles';

interface IBadgeFinancialStatusProps {
  financialStatus?: FinancialStatus;
  marginLeft?: string;
  nobkcolor?: boolean;
}

export const BadgeFinancialStatus: React.FC<IBadgeFinancialStatusProps> = ({
  financialStatus,
  marginLeft,
  nobkcolor
}) => {

  return (
    <>
      <If condition={nobkcolor == true}>
        <If condition={financialStatus == FinancialStatus.Pending}>
          <Container marginLeft={marginLeft} color='#b70e0e' bkcolor='#fff' nopadding>
            Pendente
          </Container>
        </If>
        <If condition={financialStatus == FinancialStatus.PartiallyPaid}>
          <Container marginLeft={marginLeft} color='#c5960b' bkcolor='#fff' nopadding>
            Parcialmente Pago
          </Container>
        </If>
        <If condition={financialStatus == FinancialStatus.Authorized}>
          <Container marginLeft={marginLeft} color='#5b64e0' bkcolor='#fff' nopadding>
            Autorizado
          </Container>
        </If>
        <If condition={financialStatus == FinancialStatus.Paid}>
          <Container marginLeft={marginLeft} color='#1a1ed7' bkcolor='#fff' nopadding>
            Pago
          </Container>
        </If>
        <If condition={financialStatus == FinancialStatus.PartiallyRefunded}>
          <Container marginLeft={marginLeft} color='#6164d5' bkcolor='#fff' nopadding>
            Parcialmente Reembolsado
          </Container>
        </If>
        <If condition={financialStatus == FinancialStatus.Refunded}>
          <Container marginLeft={marginLeft} color='#6164d5' bkcolor='#fff' nopadding>
            Reembolsado
          </Container>
        </If>
        <If condition={financialStatus == FinancialStatus.Voided}>
          <Container marginLeft={marginLeft} color='#9aa502' bkcolor='#fff' nopadding>
            Anulado
          </Container>
        </If>
      </If>
      <If condition={nobkcolor != true}>
        <If condition={financialStatus == FinancialStatus.Pending}>
          <Container marginLeft={marginLeft} bkcolor='#b70e0e' color='#fff' textAlign='center'>
            Pendente
          </Container>
        </If>
        <If condition={financialStatus == FinancialStatus.PartiallyPaid}>
          <Container marginLeft={marginLeft} bkcolor='#c5960b' color='#000' textAlign='center'>
            Parcialmente Pago
          </Container>
        </If>
        <If condition={financialStatus == FinancialStatus.Authorized}>
          <Container marginLeft={marginLeft} bkcolor='#5b64e0' color='#000' textAlign='center'>
            Autorizado
          </Container>
        </If>
        <If condition={financialStatus == FinancialStatus.Paid}>
          <Container marginLeft={marginLeft} bkcolor='#1a1ed7' color='#fff' textAlign='center'>
            Pago
          </Container>
        </If>
        <If condition={financialStatus == FinancialStatus.PartiallyRefunded}>
          <Container marginLeft={marginLeft} bkcolor='#6164d5' color='#fff' textAlign='center'>
            Parcialmente Reembolsado
          </Container>
        </If>
        <If condition={financialStatus == FinancialStatus.Refunded}>
          <Container marginLeft={marginLeft} bkcolor='#6164d5' color='#000' textAlign='center'>
            Reembolsado
          </Container>
        </If>
        <If condition={financialStatus == FinancialStatus.Voided}>
          <Container marginLeft={marginLeft} bkcolor='#9aa502' color='#000' textAlign='center'>
            Anulado
          </Container>
        </If>
      </If>
    </>
  );
}